export default __webpack_public_path__ + "static/media/Vegetarian.2fe0ac3b.jpg";